import { Store, ShieldCheck, BadgeCheck } from 'lucide-react';

/**
 * StoreBadges — renders "تاجر" and "وكيل معتمد" / "وكيل" badges based on
 * the `owner` object returned by CloudGM Business:
 *   { isMerchant, isAgent, isVerifiedAgent, accountType, accountTypeLabel: {ar, en} }
 *
 * A store can be BOTH a merchant AND an agent — show both badges when so.
 *
 * Props:
 *   - owner: object (from `store.owner`)
 *   - size: 'sm' (default) | 'md'
 *   - align: 'start' (default) | 'center'
 */
export default function StoreBadges({ owner, size = 'sm', align = 'start' }) {
  if (!owner) return null;
  const { isMerchant, isAgent, isVerifiedAgent } = owner;
  if (!isMerchant && !isAgent) return null;

  const px = size === 'md' ? 'px-2.5 py-1' : 'px-2 py-0.5';
  const txt = size === 'md' ? 'text-xs' : 'text-[10px]';
  const iconSize = size === 'md' ? 'h-3.5 w-3.5' : 'h-3 w-3';
  const gap = size === 'md' ? 'gap-1.5' : 'gap-1';
  const justify = align === 'center' ? 'justify-center' : '';

  return (
    <div className={`flex flex-wrap items-center ${gap} ${justify}`} data-testid="store-badges">
      {isMerchant && (
        <span
          className={`inline-flex items-center gap-1 ${px} rounded-full ${txt} font-medium bg-[#1E9BD9]/10 text-[#0284C7] border border-[#1E9BD9]/25`}
          data-testid="badge-merchant"
        >
          <Store className={iconSize} />
          <span>تاجر</span>
        </span>
      )}
      {isAgent && (
        <span
          className={`inline-flex items-center gap-1 ${px} rounded-full ${txt} font-medium ${
            isVerifiedAgent
              ? 'bg-emerald-500/10 text-emerald-600 border border-emerald-500/25'
              : 'bg-amber-500/10 text-amber-600 border border-amber-500/25'
          }`}
          data-testid={isVerifiedAgent ? 'badge-agent-verified' : 'badge-agent'}
        >
          {isVerifiedAgent ? <ShieldCheck className={iconSize} /> : <BadgeCheck className={iconSize} />}
          <span>{isVerifiedAgent ? 'وكيل معتمد' : 'وكيل'}</span>
        </span>
      )}
    </div>
  );
}
